import { ViewElement } from '../common/view';
import { RenderAppContext } from '@farris/devkit';
import { FarrisRenderEngineComponent } from '../farris-render-engine.component';

const processor = (componentRef: any, element: ViewElement, renderContext: RenderAppContext) => {
    componentRef.instance.options = element;
    componentRef.instance.renderContext = renderContext;
};

export const ComponentMap = {
    Tab: {
        typeName: 'DgTabComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor: (componentRef: any, element: ViewElement, renderContext: RenderAppContext) => {
            componentRef.instance.tab = element;
            componentRef.instance.renderContext = renderContext;
        }
    },
    Button: {
        typeName: 'DgButtonComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },
    ButtonGroup: {
        typeName: 'DgButtonGroupComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },
    ToolBar: {
        typeName: 'DgToolBarComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor: (componentRef: any, element: ViewElement, renderContext: RenderAppContext) => {
            componentRef.instance.toolbar = element;
            componentRef.instance.renderContext = renderContext;
        }
    },
    ContentContainer: {
        typeName: 'DgContainerComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },
    DisplayField: {
        typeName: 'DgLabelComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },
    TextBox: {
        typeName: 'DgTextBoxComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },
    LookupEdit: {
        typeName: 'DgLookupEditComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor: (componentRef: any, element: ViewElement, renderContext: RenderAppContext) => {
            componentRef.instance.options = element;
            componentRef.instance.renderContext = renderContext;
            componentRef.instance.viewComponentContext = renderContext.getContextById(element.id);
        }
    },
    NumericBox: {
        typeName: 'DgNumericTextBoxComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },
    Image: {
        typeName: 'DgImageComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },
    DataGrid: {
        typeName: 'DgGridComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor: (componentRef: any, element: ViewElement, renderContext: RenderAppContext) => {
            componentRef.instance.grid = element;
            componentRef.instance.renderContext = renderContext;
        }
    },
    Panel: {
        typeName: 'DgPanelComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },
    Module: {
        typeName: 'DgContainerComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },
    DateBox: {
        typeName: 'DgDateBoxComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },
    MultiTextBox: {
        typeName: 'DgMultiTextBoxComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },
    SwitchField: {
        typeName: 'DgSwitchComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },
    RadioGroup: {
        typeName: 'DgRadioGroupComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },
    CheckBox: {
        typeName: 'DgCheckBoxComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },
    CheckGroup: {
        typeName: 'DgCheckGroupComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },
    EnumField: {
        typeName: 'DgSelectComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },
    TreeGrid: {
        typeName: 'DgTreeGridComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor: (componentRef: any, element: ViewElement, renderContext: RenderAppContext) => {
            componentRef.instance.grid = element;
            componentRef.instance.renderContext = renderContext;
        }
    },
    FieldSet: {
        typeName: 'DgFieldSetComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },
    Form: {
        typeName: 'DgFormComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },
    Component: {
        typeName: 'DgComponentComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor: (componentRef: any, element: ViewElement, renderContext: RenderAppContext) => {
            componentRef.instance.options = element;
            componentRef.instance.renderContext = renderContext.getContextById(element.id);
        }
    },
    Charts: {
        typeName: 'DgChartsComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },
    ModalContainer: {
        typeName: 'DgModalContainerComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },
    Tag: {
        typeName: 'DgTagComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },
    Sidebar: {
        typeName: 'DgSidebarComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },
    HtmlTemplate: {
        typeName: 'DgHtmlTemplateComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },
    ListView: {
        typeName: 'DgListViewComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },
    RichTextBox: {
        typeName: 'DgRichTextBoxComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },
    TimeSpinner: {
        typeName: 'DgTimeSpinnerComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },
    TimePicker: {
        typeName: 'DgTimePickerComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },
    Section: {
        typeName: 'DgSectionComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },
    FormHeader: {
        typeName: 'DgFormHeaderComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },
    Splitter: {
        typeName: 'DgSplitterComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },
    InputGroup: {
        typeName: 'DgInputGroupComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },
    Avatar: {
        typeName: 'DgAvatarComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },
    ListNav: {
        typeName: 'DgListNavComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },
    NumberRange: {
        typeName: 'DgNumberRangeComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },
    Scrollspy: {
        typeName: 'DgScrollspyComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },
    LanguageTextBox: {
        typeName: 'DgLanguageTextBoxComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },
    /**
     * 多视图切换
     */
    ViewChange: {
        typeName: 'DgViewChangeComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },

    MultiViewContainer: {
        typeName: 'DgMultiViewContainerComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor: (componentRef: any, element: ViewElement, renderContext: any) => {
            componentRef.instance.views = element;
            componentRef.instance.viewGroupIdentify = element.parent.id;
            componentRef.instance.renderContext = renderContext;
        }
    },
    /**
     * 筛选方案
     */
    QueryScheme: {
        typeName: 'DgQuerySchemeComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-query-solution/main.js',
        processor: (componentRef: any, element: ViewElement, renderContext: any) => {
            componentRef.instance.options = element;
            componentRef.instance.fieldConfigs = element.fieldConfigs;
            componentRef.instance.presetFieldConfigs = element.presetFieldConfigs;
            componentRef.instance.formId = element.formId;
            componentRef.instance.presetQuerySolutionName = element.presetQuerySolutionName;
            componentRef.instance.isControlInline = element.isControlInline;
            componentRef.instance.renderContext = renderContext;
        }
    },
    /**
     * 页脚
     */
    Footer: {
        typeName: 'DgFooterComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },

    /**
     * 标签类导航
     */
    NavTab: {
        typeName: 'DgNavTabComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },

    /**
     * 标记组
     */
    Tags: {
        typeName: 'DgTagsComponent',
        sourceUri: '/platform/common/web/@farris/farris-component-common/main.js',
        processor
    },
    ExternalContainer: {
        type: FarrisRenderEngineComponent,
        processor: (componentRef: any, element: ViewElement, renderContext: any) => {

        }
    },
    ListFilter: {
        typeName: 'DgListFilterComponent',
        sourceUri: './assets/farris-component-filter/main.js',
        processor: (componentRef: any, element: ViewElement, renderContext: any) => {
            componentRef.instance.options = element;
            componentRef.instance.renderContext = renderContext;
            componentRef.instance.filterList = element.filterList;
        }
    },
};

